import api from './api';

export const verifyEmail = async (email) => {
  // Use the updated endpoint as per Swagger: /api/auth/check-email
  const response = await api.post('/auth/check-email', { email });
  return response.data;
};

export const login = async (email, password) => {
  // Use the updated login endpoint: /api/auth/login
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};
